import { queryHistoryExo, queryHistoryWave, queryHistoryWeather, queryHistoryFlow, queryHistoryWiz, queryHistoryOil, queryHistoryWeatherRecord, queryHistoryFlowLayer3 } from '@/api/historyData'

const historyData = {
  state: {
    tableColumns: [],
    historyData: [],
    total: 0
  },

  mutations: {
    SET_TABLE_COLUMNS: (state, data) => {
      state.tableColumns = data
    },
    SET_HISTORY_DATA: (state, data) => {
      state.historyData = data
    },
    SET_TOTAL: (state, data) => {
      state.total = data
    }
  },

  actions: {
    // 登录
    async queryExoHistory({ commit }, params) {
      const response = await queryHistoryExo(params)
      // return response.data
      // console.log(response.data)
      // commit('SET_BMAP_INFOS', response.data)
      if (response.data != null) {
        commit('SET_TABLE_COLUMNS', response.data.tableColumns)
        commit('SET_HISTORY_DATA', response.data.data.content)
        commit('SET_TOTAL', response.data.data.totalElements)
      }
    },
    async queryWaveHistory({ commit }, params) {
      const response = await queryHistoryWave(params)
      // return response.data
      // console.log(response.data)
      // commit('SET_BMAP_INFOS', response.data)
      if (response.data != null) {
        commit('SET_TABLE_COLUMNS', response.data.tableColumns)
        commit('SET_HISTORY_DATA', response.data.data.content)
        commit('SET_TOTAL', response.data.data.totalElements)
      }
    },
    async queryWeatherHistory({ commit }, params) {
      const response = await queryHistoryWeather(params)
      // return response.data
      // console.log(response.data)
      // commit('SET_BMAP_INFOS', response.data)
      if (response.data != null) {
        console.log(response.data)
        commit('SET_TABLE_COLUMNS', response.data.tableColumns)
        commit('SET_HISTORY_DATA', response.data.data.content)
        commit('SET_TOTAL', response.data.data.totalElements)
      }
    },
    async queryWeatherRecordHistory({ commit }, params) {
      const response = await queryHistoryWeatherRecord(params)
      // return response.data
      // console.log(response.data)
      // commit('SET_BMAP_INFOS', response.data)
      if (response.data != null) {
        console.log(response.data)
        commit('SET_TABLE_COLUMNS', response.data.tableColumns)
        commit('SET_HISTORY_DATA', response.data.data.content)
        commit('SET_TOTAL', response.data.data.totalElements)
      }
    },

    async queryWizHistory({ commit }, params) {
      const response = await queryHistoryWiz(params)
      // return response.data
      // console.log(response.data)
      // commit('SET_BMAP_INFOS', response.data)
      if (response.data != null) {
        console.log(response.data)
        commit('SET_TABLE_COLUMNS', response.data.tableColumns)
        commit('SET_HISTORY_DATA', response.data.data.content)
        commit('SET_TOTAL', response.data.data.totalElements)
      }
    },
    async queryOilHistory({ commit }, params) {
      const response = await queryHistoryOil(params)
      // return response.data
      // console.log(response.data)
      // commit('SET_BMAP_INFOS', response.data)
      if (response.data != null) {
        console.log(response.data)
        commit('SET_TABLE_COLUMNS', response.data.tableColumns)
        commit('SET_HISTORY_DATA', response.data.data.content)
        commit('SET_TOTAL', response.data.data.totalElements)
      }
    },
    async queryFlowHistory({ commit }, params) {
      const response = await queryHistoryFlow(params)
      // return response.data
      // console.log(response.data)
      // commit('SET_BMAP_INFOS', response.data)
      if (response.data != null) {
        commit('SET_TABLE_COLUMNS', response.data.tableColumns)
        commit('SET_HISTORY_DATA', response.data.data.content)
        commit('SET_TOTAL', response.data.data.totalElements)
      }
    },

    async queryFlowLayer3History({ commit }, params) {
      const response = await queryHistoryFlowLayer3(params)
      // return response.data
      // console.log(response.data)
      // commit('SET_BMAP_INFOS', response.data)
      if (response.data != null) {
        commit('SET_TABLE_COLUMNS', response.data.tableColumns)
        commit('SET_HISTORY_DATA', response.data.data.content)
        commit('SET_TOTAL', response.data.data.totalElements)
      }
    }
  }
}

export default historyData
